module.exports = __webpack_public_path__ + "images/pattern-1b01d0689ea696bee4283fa6d2c98850.png";